module.exports = __webpack_public_path__ + "img/tick_square.b977c37b.svg";